var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"members"}},[(_vm.$route.path !== _vm.localePath('/members/terms-conditions'))?_c('Header'):_vm._e(),_vm._v(" "),_c('NuxtChild')],1)}
var staticRenderFns = []

export { render, staticRenderFns }